module.exports = __webpack_public_path__ + "img/VN_BBC_footer.fc288a51.png";